import { NotificationConfiguration } from '@wedecide/models';

export const MEETING_MINUTES_SUBMIT_REVIEW: NotificationConfiguration = {
  inapp: `<b>{triggeredByName}</b> has made review comment(s).`,
  email: {
    ctaKey: 'go_to_meeting_minutes',
  },
};
